module.exports = __webpack_public_path__ + "static/media/wolfpack1.82726f30.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/projects/labatt/wolfpack1.png
// module id = 757
// module chunks = 0